import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const DetailsWidgetsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfileDetails' */ './components/DetailsWidgets'
		)
);

export default () => ({
	index: true,
	element: <AsyncLoading component={<DetailsWidgetsLazy />} />,
});
